// extracted by mini-css-extract-plugin
export default {"root":"QwxLu3","onImage":"wdExWB"};